import src from "IMAGE";
export default { src, width: 281, height: 85, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AHRccYONfKG9NjE+PCYQGyAeDxocGBIeHRUVJSIOFiUgAHhfdYePfaS/OTNBPyYRHCAdDxkbGRIfHhUWJiMNFCMfK5YOYGkrtycAAAAASUVORK5CYII="};
